module.exports = [
	{
		"name": "All Items",
		"url": "/category/all",
		"children": [
			{
				"name": "Popular Files",
				"url": "/page/top_sellers"
			},
			{
				"name": "Featured Files",
				"url": "/feature"
			},
			{
				"name": "Top New Files",
				"url": "/search?date=this-month&length_max=&length_min=&price_max=&price_min=&rating_min=&sales=&sort=sales&term=&utf8=%E2%9C%93&view=list"
			},
			{
				"name": "Follow Feed",
				"url": "/follow_feed"
			},
			{
				"name": "Top Authors",
				"url": "/authors/top"
			},
			{
				"name": "Top New Authors",
				"url": "/page/top_new_sellers"
			},
			{
				"name": "Public Collections",
				"url": "/collections"
			},
			{
				"name": "View All Categories",
				"url": "/category"
			}
		]
	},
	{
		"name": "WordPress",
		"url": "/category/wordpress",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=wordpress",
				"isTop": true
			},
			{
				"name": "Blog / Magazine",
				"url": "/category/wordpress/blog-magazine"
			},
			{
				"name": "BuddyPress",
				"url": "/category/wordpress/buddypress"
			},
			{
				"name": "Corporate",
				"url": "/category/wordpress/corporate"
			},
			{
				"name": "Creative",
				"url": "/category/wordpress/creative"
			},
			{
				"name": "Directory & Listings",
				"url": "/category/wordpress/corporate/directory-listings"
			},
			{
				"name": "eCommerce",
				"url": "/category/wordpress/ecommerce"
			},
			{
				"name": "Education",
				"url": "/category/wordpress/education"
			},
			{
				"name": "Entertainment",
				"url": "/category/wordpress/entertainment"
			},
			{
				"name": "Layers WP",
				"url": "/attributes/compatible-with/layers%20wp"
			},
			{
				"name": "Mobile",
				"url": "/category/wordpress/mobile"
			},
			{
				"name": "Nonprofit",
				"url": "/category/wordpress/nonprofit"
			},
			{
				"name": "Real Estate",
				"url": "/category/wordpress/real-estate"
			},
			{
				"name": "Retail",
				"url": "/category/wordpress/retail"
			},
			{
				"name": "Technology",
				"url": "/category/wordpress/technology"
			},
			{
				"name": "Wedding",
				"url": "/category/wordpress/wedding"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/wordpress/miscellaneous"
			},
			{
				"name": "WordPress Plugins on CodeCanyon",
				"url": "https://codecanyon.net/category/wordpress",
				"isBottom": true
			}
		]
	},
	{
		"name": "Hosted WordPress",
		"url": "/wordpress/hosted",
		"children": [],
		"isNew": true
	},
	{
		"name": "HTML",
		"url": "/category/site-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=site-templates",
				"isTop": true
			},
			{
				"name": "Admin Templates",
				"url": "/category/site-templates/admin-templates"
			},
			{
				"name": "Corporate",
				"url": "/category/site-templates/corporate"
			},
			{
				"name": "Creative",
				"url": "/category/site-templates/creative"
			},
			{
				"name": "Entertainment",
				"url": "/category/site-templates/entertainment"
			},
			{
				"name": "Mobile",
				"url": "/category/site-templates/mobile"
			},
			{
				"name": "Nonprofit",
				"url": "/category/site-templates/nonprofit"
			},
			{
				"name": "Personal",
				"url": "/category/site-templates/personal"
			},
			{
				"name": "Retail",
				"url": "/category/site-templates/retail"
			},
			{
				"name": "Specialty Pages",
				"url": "/category/site-templates/specialty-pages"
			},
			{
				"name": "Technology",
				"url": "/category/site-templates/technology"
			},
			{
				"name": "Wedding",
				"url": "/category/site-templates/wedding"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/site-templates/miscellaneous"
			}
		]
	},
	{
		"name": "Marketing",
		"url": "/category/marketing",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=marketing",
				"isTop": true
			},
			{
				"name": "Email Templates",
				"url": "/category/marketing/email-templates"
			},
			{
				"name": "Instapage",
				"url": "/category/marketing/instapage"
			},
			{
				"name": "Landing Pages",
				"url": "/category/marketing/landing-pages"
			},
			{
				"name": "Pagewiz",
				"url": "/category/marketing/pagewiz"
			},
			{
				"name": "Unbounce Landing Pages",
				"url": "/category/marketing/unbounce-landing-pages"
			},
			{
				"name": "Google Web Designer Ads on CodeCanyon",
				"url": "http://codecanyon.net/category/html5/ad-templates?platform=Google%2BWeb%2BDesigner",
				"isBottom": true
			}
		]
	},
	{
		"name": "CMS",
		"url": "/category/cms-themes",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=cms-themes",
				"isTop": true
			},
			{
				"name": "Concrete5",
				"url": "/category/cms-themes/concrete5"
			},
			{
				"name": "Drupal",
				"url": "/category/cms-themes/drupal"
			},
			{
				"name": "Joomla",
				"url": "/category/cms-themes/joomla"
			},
			{
				"name": "MODX Themes",
				"url": "/category/cms-themes/modx-themes"
			},
			{
				"name": "Moodle",
				"url": "/category/cms-themes/moodle"
			},
			{
				"name": "Mura",
				"url": "/category/cms-themes/mura"
			},
			{
				"name": "Webflow",
				"url": "/category/cms-themes/webflow"
			},
			{
				"name": "Weebly",
				"url": "/category/cms-themes/weebly"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/cms-themes/miscellaneous"
			}
		]
	},
	{
		"name": "eCommerce",
		"url": "/category/ecommerce",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=ecommerce",
				"isTop": true
			},
			{
				"name": "WooCommerce",
				"url": "/category/wordpress/ecommerce/woocommerce"
			},
			{
				"name": "3dcart",
				"url": "/category/ecommerce/3dcart"
			},
			{
				"name": "BigCommerce",
				"url": "/category/ecommerce/bigcommerce"
			},
			{
				"name": "Cart66",
				"url": "/category/wordpress/ecommerce/cart66"
			},
			{
				"name": "CS-Cart",
				"url": "/category/ecommerce/cs-cart"
			},
			{
				"name": "Drupal Commerce",
				"url": "/attributes/compatible-with/Drupal Commerce?sort=date"
			},
			{
				"name": "Easy Digital Downloads",
				"url": "/search?compatible_with=Easy+Digital+Downloads"
			},
			{
				"name": "Ecwid",
				"url": "/attributes/themeforest-files-included/ecwid%20css%20files"
			},
			{
				"name": "Jigoshop",
				"url": "/category/wordpress/ecommerce/jigoshop"
			},
			{
				"name": "Magento",
				"url": "/category/ecommerce/magento"
			},
			{
				"name": "OpenCart",
				"url": "/category/ecommerce/opencart"
			},
			{
				"name": "osCommerce",
				"url": "/category/ecommerce/oscommerce"
			},
			{
				"name": "PrestaShop",
				"url": "/category/ecommerce/prestashop"
			},
			{
				"name": "Shopify",
				"url": "/category/ecommerce/shopify"
			},
			{
				"name": "Ubercart",
				"url": "/attributes/compatible-with/Ubercart?sort=date"
			},
			{
				"name": "VirtueMart",
				"url": "/category/cms-themes/joomla/virtuemart"
			},
			{
				"name": "WP e-Commerce",
				"url": "/category/wordpress/ecommerce/wp-e-commerce"
			},
			{
				"name": "Zen Cart",
				"url": "/category/ecommerce/zen-cart"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/ecommerce/miscellaneous"
			}
		]
	},
	{
		"name": "Muse",
		"url": "/category/muse-templates",
		"children": [
			{
				"name": "Popular Items",
				"url": "/popular_item/by_category?category=muse-templates",
				"isTop": true
			},
			{
				"name": "Corporate",
				"url": "/category/muse-templates/corporate"
			},
			{
				"name": "Creative",
				"url": "/category/muse-templates/creative"
			},
			{
				"name": "eCommerce",
				"url": "/category/muse-templates/ecommerce"
			},
			{
				"name": "Landing",
				"url": "/category/muse-templates/landing"
			},
			{
				"name": "Personal",
				"url": "/category/muse-templates/personal"
			},
			{
				"name": "Miscellaneous",
				"url": "/category/muse-templates/miscellaneous"
			},
			{
				"name": "Muse Widgets on CodeCanyon",
				"url": "http://codecanyon.net/category/plugins/muse-widgets",
				"isBottom": true
			}
		]
	},
	{
		"name": "UI Design",
		"url": "/category/sketch-templates",
		"children": [
			{
				"name": "PSD Templates",
				"url": "/category/psd-templates"
			},
			{
				"name": "Popular PSD Templates",
				"url": "/popular_item/by_category?category=psd-templates\n        "
			},
			{
				"name": "Sketch Templates",
				"url": "/category/sketch-templates"
			},
			{
				"name": "Popular Sketch Templates",
				"url": "/popular_item/by_category?category=sketch-templates"
			}
		]
	},
	{
		"name": "Plugins",
		"url": "https://codecanyon.net/category/wordpress",
		"children": []
	},
	{
		"name": "More",
		"url": "/category",
		"children": [
			{
				"name": "Blogging",
				"url": "/category/blogging"
			},
			{
				"name": "Courses",
				"url": "/category/courses"
			},
			{
				"name": "Facebook Templates",
				"url": "/attributes/compatible-with/facebook"
			},
			{
				"name": "Forums",
				"url": "/category/forums"
			},
			{
				"name": "Ghost Themes",
				"url": "/category/blogging/ghost-themes"
			},
			{
				"name": "Hosting",
				"url": "/get_hosting"
			},
			{
				"name": "Jekyll",
				"url": "/category/static-site-generators/jekyll"
			},
			{
				"name": "Tumblr",
				"url": "/category/blogging/tumblr"
			},
			{
				"name": "TypeEngine Themes",
				"url": "/category/typeengine-themes"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/menus/themeforest.json
// module id = 483
// module chunks = 1